import axiosIns from '@/axios'

export const defaultBrandLinkMenu = [
  {
    title: 'Bio',
    route: 'bio',
    icon: 'UserIcon',
  },
  {
    title: 'Story',
    route: { name: 'campaign', params: { type: 'story' } },
    icon: 'ImageIcon',
  },
  {
    title: 'Sms',
    route: { name: 'campaign', params: { type: 'sms' } },
    icon: 'MessageSquareIcon',
  },
  {
    title: 'Whatsapp',
    route: { name: 'campaign', params: { type: 'whatsapp' } },
    icon: 'MessageCircleIcon',
  },
]

export const getBrandLinkMenuItems = async () => {
  try {
    const res = await axiosIns.get('/link/type')
    const items = (res.data?.data || []).filter(x => Number(x.status) === 1 && x.id!== 0)

    return items.map(item => ({
      title: item.name,
      route: item.model === 'bio'
        ? { name: 'bio', params: { key: item.key } }
        : { name: 'campaign', params: { type: item.key } },
      icon: 'LinkIcon',
    }))
  } catch (error) {
    return defaultBrandLinkMenu
  }
}

export const navMenuItems = [
  {
    title: 'Anasayfa',
    route: 'home',
    icon: 'HomeIcon',
  },
  {
    title: 'Yönetici Paneli',
    icon: 'ActivityIcon',
    role: 'developer,sale_team',  
    children: [
      
      {
        title: 'Müşteri Listesi',
        route: 'customers',
        icon: 'AwardIcon',
        role: 'developer,sale_team',
      },
      {
        title: 'Demo Talepleri',
        route: 'demo-requests',
        icon: 'AwardIcon',
        role: 'developer,sale_team',
      },
      {
        title: 'Müşteri Kullanımı',
        route: 'customers-used',
        icon: 'AwardIcon',
        role: 'sale_team',
      },
      {
        title: 'Events Kullanımı',
        route: 'customers-used-events',
        icon: 'ActivityIcon',
        role: 'sale_team',
      },
      {
        title: 'İzin Yönetimi',
        route: 'permissions',
        icon: 'LinkIcon',
        role: 'developer'
      },
      {
        title: 'Paket Fiyatlandırma',
        route: 'price',
        icon: 'PackageIcon',
        role: 'developer'
      },
      {
        title: 'Test Sistemi',
        route: 'test-runner',
        icon: 'PackageIcon',
        role: 'developer'
      },
      {
        title: 'Domain Yönetimi',
        route: 'domains',
        icon: 'PackageIcon',
        role: 'developer'
      },
    ]
  },
  {
    title: 'Influencer, Hesabım',
    icon: 'Share2Icon',
    children: [
      {
        title: 'Fenomenler',
        route: 'influencers',
        icon: 'UsersIcon',
        role: 'admin',
      },
      {
        title: 'Paylaşımlar',
        route: { name: 'campaign', params: { type: 'influencer' } },
        icon: 'LinkIcon',
      },
      {
        title: 'Olaylar',
        icon: 'ActivityIcon',
        children: [
          {
            title: 'Sayfa Ziyaretleri',
            route: { name: 'click', params: { type: 'influencer' } },
            icon: 'MousePointerIcon',
          },
          {
            title: 'Sepet Datası',
            route: { name: 'carts', params: { type: 'influencer' } },
            icon: 'ShoppingCartIcon',
          },
          {
            title: 'Sipariş Datası',
            route: { name: 'orders', params: { type: 'influencer' } },
            icon: 'FileTextIcon',
          },
        ],
      },
      {
        title: 'Hakedişler',
        route: 'vesting',
        icon: 'CreditCardIcon',
      },
      {
        title: 'Ödemeler',
        route: 'vesting-payment',
        icon: 'BriefcaseIcon',
      },
    ],
  },
  {
    title: 'Marka',
    icon: 'PackageIcon',
    role: 'admin',
    children: [
      {
        title: 'Olaylar',
        icon: 'ActivityIcon',
        children: [
          {
            title: 'Sayfa Ziyaretleri',
            route: { name: 'click', params: { type: 'account' } },
            icon: 'MousePointerIcon',
          },
          {
            title: 'Sepet Datası',
            route: { name: 'carts', params: { type: 'account' } },
            icon: 'ShoppingCartIcon',
          },
          {
            title: 'Sipariş Datası',
            route: { name: 'orders', params: { type: 'account' } },
            icon: 'FileTextIcon',
          },
        ],
      },
      // ...brandLinkTypes,
      // {
      //   title: 'Bio',
      //   route: 'bio',
      //   icon: 'UserIcon',
      // },
      // {
      //   title: 'Story',
      //   route: { name: 'campaign', params: { type: 'story' } },
      //   icon: 'ImageIcon',
      // },
      // {
      //   title: 'Sms',
      //   route: { name: 'campaign', params: { type: 'sms' } },
      //   icon: 'MessageSquareIcon',
      // },
      // {
      //   title: 'Whatsapp',
      //   route: { name: 'campaign', params: { type: 'whatsapp' } },
      //   icon: 'MessageCircleIcon',
      // },
      // {
      //   title: 'Email',
      //   route: { name: 'campaign', params: { type: 'email' } },
      //   icon: 'MailIcon',
      // },
      // {
      //   title: 'Web Push',
      //   route: { name: 'campaign', params: { type: 'webpush' } },
      //   icon: 'BellIcon',
      // },
      // {
      //   title: 'Storly',
      //   route: { name: 'multi-links', params: { id: 8 } },
      //   icon: 'PlayCircleIcon',
      //   role: 'admin',
      // },
      // {
      //   title: 'Banner Yönetimi',
      //   route: { name: 'campaign', params: { type: 'banner' } },
      //   icon: 'PlayCircleIcon',
      //   role: 'admin',
      // },
    ],
  },
  {
    title: 'Performans Analizi',
    icon: 'BarChartIcon',
    route: { name: 'analysis-links', params: { type: 'influencer' } },
    role: 'influencer',
  },
  {
    title: 'Performans Analizi',
    icon: 'BarChartIcon',
    role: 'admin',
    children: [
      {
        title: 'Fenomen',
        route: { name: 'analysis-fenomen'},
        icon: 'UsersIcon',
      },
      {
        title: 'Paylaşım',
        route: { name: 'analysis-links', params: { type: 'influencer' } },
        icon: 'Link2Icon',
      },
      {
        title: 'Kampanya',
        route: { name: 'analysis-multi-links', params: { type: 'multi-links' } },
        icon: 'TargetIcon',
      },
      {
        title: 'Story',
        route: { name: 'analysis-links', params: { type: 'story' } },
        icon: 'ImageIcon',
        role: 'admin',
      },
      {
        title: 'Sms',
        route: { name: 'analysis-links', params: { type: 'sms' } },
        icon: 'MessageSquareIcon',
        role: 'admin',
      },
      {
        title: 'Whatsapp',
        route: { name: 'analysis-links', params: { type: 'whatsapp' } },
        icon: 'MessageCircleIcon',
        role: 'admin',
      },
      {
        title: 'Banner',
        route: { name: 'analysis-links', params: { type: 'banner' } },
        icon: 'MessageCircleIcon',
        role: 'admin',
      },
    ],
  },
  {
    title: 'Ürünler',
    route: 'products',
    icon: 'LinkIcon',
  },
  
  {
    title: 'Yardım Merkezi',
    route: 'help',
    icon: 'HelpCircleIcon',
    role: 'admin'
  },
];


export const bottomMenuItems = [
  {
    title: 'Kullanıcı Listesi',
    route: 'admins',
    icon: 'UsersIcon',
    role: 'admin'
  },
  {
    title: 'UTM Ayarları',
    route: 'utm-setting',
    icon: 'LinkIcon',
    role: 'admin'
  },
  {
    title: 'Ayarlar',
    route: 'settings',
    icon: 'SettingsIcon',
    role: 'admin'
  },
  {
    title: 'Platformlar',
    route: 'platforms',
    icon: 'ScissorsIcon',
    role: 'admin'
  },
  {
    title: 'Link Tipleri',
    route: 'link-types',
    icon: 'LinkIcon',
    role: 'developer'
  },
  {
    title: 'Geliştirme Notları',
    route: 'developer-notes',
    icon: 'CodepenIcon',
    role: 'admin'
  },
  {
    title: 'Kurulum',
    route: 'setup',
    icon: 'CodeIcon',
    role: 'admin'
  },
  {
    title: 'Log Kayıtları',
    route: 'logs',
    icon: 'CodeIcon',
    role: 'admin'
  },
]